import React from 'react';
import { GetServerSideProps } from 'next';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Banner from '@components/Banner';
import HeadSEO from '@components/HeadSEO';
import htmlParse from 'html-react-parser';

const PolicyPage = () => {
  const { t } = useTranslation();

  const itemBreadcrumbs = [
    {
      name: t('common.home'),
      path: '/',
    },
    {
      name: t('common.txtPolicy'),
      path: '/about/privacy-policy',
    },
  ];

  const listContent = [
    t('policy.txtWhoWeAre'),
    t('policy.txtWhatPerson'),
    t('policy.txtWhyWe'),
    t('policy.txtWhyWeShare'),
    t('policy.txtWhatRight'),
    t('policy.txtCookies'),
    t('policy.txtNotice'),
  ];

  return (
    <div className="about-us page-policy">
      <HeadSEO
        title={t('policy.titleHead')}
        description={t('policy.descHead')}
        image="/images/preview/home.jpg"
      />
      <Banner title={t('common.txtPolicy')} itemBreadcrumbs={itemBreadcrumbs} />
      <div className="policy-content">
        <div className="container">
          {listContent.map((vl, idx) => (
            <div key={idx}>{htmlParse(vl)}</div>
          ))}
        </div>
      </div>
    </div>
  );
};
export const getServerSideProps: GetServerSideProps = async ({
  locale,
}: any) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
};
export default PolicyPage;
